/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Breadcrumbs, Link } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  breadcrumb: {
    color: "#202020",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    "&:hover": {
      color: "#CC0000",
      background: "-webkit-linear-gradient(#F74134, #EB1C61)",
      "-webkit-background-clip": "text",
      "-webkit-text-fillColor": "transparent",
    },
  },
  breadcrumbFinal: {
    color: "#616161",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.5rem",
    "&:hover": {
      color: "#CC0000",
      background: "-webkit-linear-gradient(#F74134, #EB1C61)",
      "-webkit-background-clip": "text",
      "-webkit-text-fillColor": "transparent",
    },
  },
}));

const Breadkrumbs = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <Breadcrumbs separator="›" aria-label="breadcrumbs">
        <Link
          rel="noopener"
          title="Transaction Type"
          href={
            "/properties?q=" +
            encodeURIComponent(props.q ? props.q : "") +
            "&c=any" +
            "&t=" +
            encodeURIComponent(props.t ? props.t : "any")
          }
          className={classes.breadcrumb}
        >
          {props.t
            ? props.t.substring(0, 1).toUpperCase() + props.t.slice(1)
            : "Any"}
        </Link>
        <Link
          rel="noopener"
          title="Transaction Type"
          href={
            "/properties?q=" +
            encodeURIComponent(props.q ? props.q : "") +
            "&c=" +
            encodeURIComponent(props.c ? props.c : "any") +
            "&t=any"
          }
          className={classes.breadcrumb}
        >
          {props.c
            ? props.c.substring(0, 1).toUpperCase() + props.c.slice(1)
            : "Any"}
        </Link>
        <Link
          rel="noopener"
          title="Transaction Type"
          href={
            "/properties?q=" +
            encodeURIComponent(props.location ? props.location : "JP Nagar") +
            "&c=" +
            encodeURIComponent(props.c ? props.c : "any") +
            "&t=any"
          }
          className={classes.breadcrumb}
        >
          {props.location ? props.location : "JP Nagar"}
        </Link>
        <Link
          rel="noopener"
          title="Transaction Type"
          href={"/properties/" + (props.slug ? props.slug : "unknown-property")}
          className={classes.breadcrumbFinal}
        >
          {props.title ? props.title : "Vaishnavi Terraces"}
        </Link>
      </Breadcrumbs>
    );
  } else {
    return (
      <Skeleton>
        <Breadcrumbs separator="›" aria-label="breadcrumbs">
          <Link
            rel="noopener"
            title="Transaction Type"
            href={
              "/properties?q=" +
              encodeURIComponent(props.q ? props.q : "") +
              "&c=any" +
              "&t=" +
              encodeURIComponent(props.t ? props.t : "any")
            }
            className={classes.breadcrumb}
          >
            {props.t
              ? props.t.substring(0, 1).toUpperCase() + props.t.slice(1)
              : "Any"}
          </Link>
          <Link
            rel="noopener"
            title="Transaction Type"
            href={
              "/properties?q=" +
              encodeURIComponent(props.q ? props.q : "") +
              "&c=" +
              encodeURIComponent(props.c ? props.c : "any") +
              "&t=any"
            }
            className={classes.breadcrumb}
          >
            {props.c
              ? props.c.substring(0, 1).toUpperCase() + props.c.slice(1)
              : "Any"}
          </Link>
          <Link
            rel="noopener"
            title="Transaction Type"
            href={
              "/properties?q=" +
              encodeURIComponent(props.location ? props.location : "JP Nagar") +
              "&c=" +
              encodeURIComponent(props.c ? props.c : "any") +
              "&t=any"
            }
            className={classes.breadcrumb}
          >
            {props.location ? props.location : "JP Nagar"}
          </Link>
          <Link
            rel="noopener"
            title="Transaction Type"
            href={
              "/properties/" + (props.slug ? props.slug : "unknown-property")
            }
            className={classes.breadcrumbFinal}
          >
            {props.title ? props.title : "Vaishnavi Terraces"}
          </Link>
        </Breadcrumbs>
      </Skeleton>
    );
  }
};

export default Breadkrumbs;
